import { render, staticRenderFns } from "./modal-detalhe-prontuario.vue?vue&type=template&id=5510a448&scoped=true"
import script from "./modal-detalhe-prontuario.vue?vue&type=script&lang=js"
export * from "./modal-detalhe-prontuario.vue?vue&type=script&lang=js"
import style0 from "./modal-detalhe-prontuario.vue?vue&type=style&index=0&id=5510a448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510a448",
  null
  
)

export default component.exports